import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tail from '../../shared/feed/styles';
import dt from '../../../shared/theme';
import InfiniteScrollEndText from '../../shared/infinite-scroll-end-text';
import useGetWiresForSeries from '../../../services/wires/series-wires-service';
import Headline from './headline';
import Wires from './wires';
import useScrollableWires from './scrollable-wires-hooks';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  ${props => dt(props).theme.isMobileOrTablet && `
    width: 100%;
    padding: 0 20px;
  `};
  ${props => dt(props).theme.isLarge && `
    padding: 0 32px;
  `};
  ${props => dt(props).theme.isXLarge && `
    width: 953px;
    padding: 0;
  `};
  ${props => dt(props).theme.isXXLarge && `
    width: 1200px;
    padding: 0;
  `};

  > .tail {
    margin-bottom: 40px;
  }
`;

export default function Main({ seriesSlug, numberOfWires }) {
  const {
    wires, infiniteRef, expandList, showExpand, hasMore,
  } = useScrollableWires({ useGetWires: () => useGetWiresForSeries(seriesSlug) });

  if (wires.length === 0) {
    return null;
  }

  return (
    <Container>
      <Headline total={numberOfWires} />
      <Wires wires={wires} />
      <div ref={infiniteRef} />
      {!!showExpand && (
        <Tail className="tail"><button type="button" onClick={expandList}>show more</button></Tail>
      )}
      {!hasMore && <InfiniteScrollEndText text="You have seen all the results" />}
    </Container>
  );
}

Main.propTypes = {
  seriesSlug: PropTypes.string.isRequired,
  numberOfWires: PropTypes.number.isRequired,
};
